import { useResetProjectMilestonesModalMutation } from 'generated/graphql';
import React from 'react';

export function useResetMilestones() {
  const [
    fnMutate,
    tuple
  ] = useResetProjectMilestonesModalMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
